import request from "../utils/request";
import store from "../store/index"
import { APP_API_BASE_URL } from "../utils/env"
const schemeApi = {
    SchemeList: 'questionnaire/tab',
    copyQues: 'questionnaire/v2',
    copyQuesModule: 'questionnaire/moudle/v2',
    excelUrl: 'questionnaire/interface/choice/import',
    quesAnswer: APP_API_BASE_URL + 'questionnaire/answers/findPage',
    quesExport: APP_API_BASE_URL + 'questionnaire/answers/export',
    quesDownload: APP_API_BASE_URL + 'questionnaire/down_excel',
}


export function getTab(params) {
    return request({
        url: schemeApi.SchemeList,
        method: "get",
        params: params,
    })
}

export function copyQues(parameter) {
    return request({
        url: schemeApi.copyQues,
        method: "post",
        data: parameter,

    })
}
export function copyQuesModule(parameter) {
    return request({
        url: schemeApi.copyQuesModule,
        method: "post",
        data: parameter,

    })
}

export function getImport(baseUrl, params) {
    return request({
        url: baseUrl || schemeApi.excelUrl,
        method: "get",
        params: params,
    })
}

export function quesAnswer(parameter) {
    return request({
        url: schemeApi.quesAnswer,
        method: "post",
        data: parameter,
    })
}


export function quesExport(parameter) {
    return request({
        url: schemeApi.quesExport,
        method: "post",
        data: parameter,
    })
}


export function quesDownload(params) {
    return request({
        url: schemeApi.quesDownload,
        method: "get",
        params: params,
    })
}